import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/lib/locale/pt';
import { colors } from 'vuetify/lib';

Vue.use(Vuetify);
/**
 Branco: #FFFFFF
Azul: #001e62
Vermelho/Rosa: #e0004d
Verde: #009C3B
Gelo azul: #E6E6FA
Telegram: #25A3E1
 */
export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary:'#001e62',
        secondary: colors.teal.accent4,
        accent: '#8c9eff',
        error: '#b71c1c',
        //
        cor_detalhe:'#a60851',
        btn_mais_protecao:'#e0004d',
        color_alert:'#e0004d',
        telegram:'#25A3E1',
        verde:'#009C3B',


      },
      dark:{
        primary:'#001e62',
          //
          cor_detalhe:'#a60851',
          btn_mais_protecao:'#e0004d',
          color_alert:'#e0004d',
          telegram:'#25A3E1',
          verde:'#009C3B',
      }
    },
  },
    lang: {
      locales: { pt },
      current: 'pt',
    },
});
